import { render, staticRenderFns } from "./PartialLeadHistoryCsat.vue?vue&type=template&id=2784d116&scoped=true&"
import script from "./PartialLeadHistoryCsat.vue?vue&type=script&lang=js&"
export * from "./PartialLeadHistoryCsat.vue?vue&type=script&lang=js&"
import style0 from "./PartialLeadHistoryCsat.vue?vue&type=style&index=0&id=2784d116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784d116",
  null
  
)

export default component.exports